/**
 * Loading Spinner Komponente
 */

import React from "react";
import { CircularProgress, Box, Typography, styled } from "@mui/material";

interface LoadingSpinnerProps {
  size?: "small" | "medium" | "large";
  text?: string;
}

const LoadingContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "40px 20px",
  minHeight: "200px",
});

const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  marginBottom: "16px",
  background: "linear-gradient(45deg, #667eea 30%, #764ba2 90%)",
  borderRadius: "50%",
}));

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "medium",
  text = "Lädt...",
}) => {
  const getSize = () => {
    switch (size) {
      case "small":
        return 24;
      case "large":
        return 60;
      default:
        return 40;
    }
  };

  return (
    <LoadingContainer>
      <StyledCircularProgress
        size={getSize()}
        thickness={4}
        sx={{
          color: "primary.main",
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          },
        }}
      />
      {text && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            fontWeight: 500,
            textAlign: "center",
            fontSize: size === "small" ? "0.875rem" : "1rem",
          }}
        >
          {text}
        </Typography>
      )}
    </LoadingContainer>
  );
};

export default LoadingSpinner;
